export default __webpack_public_path__ + "static/media/liz__O8A9903_final.c5596f5d.jpg";